import React, { useState, useEffect } from 'react';
import { Button, Text } from '@chakra-ui/react';
import { refundOrder, getPaymentAmount } from '../api';
import { ModalInfo } from './ModalInfo';

const RefundButton = ({
  orderId,
  paymentId,
  paymentType,
  status,
  settledBy,
  onRefundSuccess, // Callback opzionale quando il rimborso ha successo
  buttonProps = {}, // Props aggiuntive per personalizzare il pulsante
}) => {
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showResultModal, setShowResultModal] = useState(false);
  const [refundResult, setRefundResult] = useState({ success: false, message: '' });
  const [isRefunding, setIsRefunding] = useState(false);
  const [paymentAmount, setPaymentAmount] = useState(null);
  const [isLoadingAmount, setIsLoadingAmount] = useState(false);

  // Recupera l'importo del pagamento quando il componente si monta
  useEffect(() => {
    const fetchPaymentAmount = async () => {
      
      setIsLoadingAmount(true);
      try {
        // A) paymentId for stripe, orderId for acube
        const result = await getPaymentAmount(paymentId, orderId);
        // console.log('====>>>>> result', result);
        if (result.success) {
          setPaymentAmount(result.formattedAmount);
        }
      } catch (error) {
        console.error('Errore nel recupero dell\'importo:', error);
      } finally {
        setIsLoadingAmount(false);
      }
    };

    fetchPaymentAmount();
  }, [paymentId, orderId, status]);


  const handleRefundClick = () => {
    setShowConfirmModal(true);
  };

  const handleConfirmRefund = async () => {
    setShowConfirmModal(false);
    setIsRefunding(true);

    try {
      // D) Se volessi supportare anche rimborso cashier, devo passare anche orderId
      const result = await refundOrder(paymentId, orderId);

      if (result.success) {
        setRefundResult({
          success: true,
          message:
            "Rimborso effettuato con successo!",
        });
      } else {
        setRefundResult({
          success: false,
          message: `Errore durante il rimborso: ${result.error}`,
        });
      }
    } catch (error) {
      setRefundResult({
        success: false,
        message: `Errore durante il rimborso: ${error.response.data.error}`,
      });
    } finally {
      setIsRefunding(false);
      setShowResultModal(true);
    }
  };

  const handleResultModalClose = () => {
    setShowResultModal(false);
    if (refundResult.success && onRefundSuccess) {
      onRefundSuccess();
    }
  };

  // Non mostrare il pulsante se:
  // DEPRECATO - Non ha paymentId (NO STRIPE)
  // E' un ordine gratuito per via dei voucher (paymentId === orderId)
  // E' già stato rimborsato (status === 'refunded')
  // E' un ordine omaggio (paymentType === 'free')
  // E' stato evaso (settledBy && settledBy.length > 0)
  // Non e' stato pagato (status !== 'paid')


  if (paymentId === orderId) {
    return <Text>non rimborsabile (voucher)</Text>;
  }
  if (status === 'refunded') {
    return <Text>non rimborsabile (già rimborsato)</Text>;
  }
  if (paymentType === 'free') {
    return <Text>non rimborsabile (omaggio)</Text>;
  }
  if (settledBy && settledBy.length > 0) {
    return <Text>non rimborsabile (già evaso)</Text>;
  }
  if (status !== 'paid') {
    return <Text>non rimborsabile (non pagato)</Text>;
  }

  return (
    <>
      <Button
        size='sm'
        // colorScheme='red'
        // variant='outline'
        onClick={handleRefundClick}
        isLoading={isRefunding || isLoadingAmount}
        loadingText={isRefunding ? 'Rimborsando...' : 'Caricamento...'}
        {...buttonProps}
      >
        {paymentAmount ? `Rimborsa ${paymentAmount}` : 'Rimborsa'}
      </Button>

      {/* Modal di conferma */}
      <ModalInfo
        title='Conferma rimborso'
        body={
          <Text>
            Sei sicuro di voler rimborsare l'ordine{' '}
            <Text as='span' fontWeight='bold'>
              {orderId}
            </Text>
            {paymentAmount && (
              <>
                {' '}di{' '}
                <Text as='span' fontWeight='bold' color='green.500'>
                  {paymentAmount}
                </Text>
              </>
            )}
            ?
            <br />
            <br />
            {paymentId && (
              <>
                <Text as='span' fontSize='xl' fontWeight='bold' color='green.500'>
                  L'importo verrà rimborsato in automatico entro 5-10 giorni lavorativi.
                </Text>
              </>
            )}
            {!paymentId && (
              <>
                <Text as='span' fontSize='xl' fontWeight='bold' color='green.500'>
                  L'importo deve essere rimborsato dall'admin.
                </Text>
              </>
            )}
            
          </Text>
        }
        isOpen={showConfirmModal}
        onClose={handleConfirmRefund}
        onCloseText='Conferma rimborso'
        onCancel={() => setShowConfirmModal(false)}
        onCancelText='Annulla'
      />

      {/* Modal del risultato */}
      <ModalInfo
        title={refundResult.success ? 'Rimborso completato' : 'Errore rimborso'}
        body={
          <Text color={refundResult.success ? 'green.500' : 'red.500'}>{refundResult.message}</Text>
        }
        isOpen={showResultModal}
        onClose={handleResultModalClose}
        onCloseText='OK'
      />
    </>
  );
};

export default RefundButton;
